import { useEffect } from 'react';

/** Название продукта -- словесный знак, одинаковый на любом языке */
const PRODUCT_NAME = 'Quantum Hash';

/**
 * Заголовок вкладки страницы маршрута (макет prototype.js:600): «Title — Quantum Hash» или
 * просто «Quantum Hash», если title пустой. Хук вызывает каждая страница маршрута (проверка
 * tests/unit/everyRouteSetsTitle.test.ts); ушедшая страница свой заголовок снимает, чтобы
 * следующая, пока грузится, не показывала чужое имя.
 */
export function usePageTitle(title: string): void {
	useEffect(() => {
		document.title = title ? `${title} — ${PRODUCT_NAME}` : PRODUCT_NAME;
	}, [title]);

	useEffect(
		() => () => {
			document.title = PRODUCT_NAME;
		},
		[],
	);
}
